// extracted by mini-css-extract-plugin
export const root = "video-embed-section-module--root--1DQXY";
export const embed = "video-embed-section-module--embed--3iss6";